import { Typography, TypographyProps } from '@mui/material';

export const SemiBoldTypography = (props: TypographyProps) => (
  <Typography fontWeight={600} {...props} />
);
